import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  Hidden,
  TextField,
  Typography,
} from "@mui/material";
import swal from "sweetalert";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import _ from "lodash";
import ReceiptIcon from '@mui/icons-material/Receipt';
// import * as swal from 'sweetalert';
import Swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import overlayFactory from "react-bootstrap-table2-overlay";
import { format } from "date-fns";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";
import { removeFilterTitle } from "../../util/removeFilterTitle";


function Showcertificate() {

  const [productInput, setProduct] = useState({
    vertical_name: "",
  });
  const [sublist, setsublist] = useState([]);

 

  //  first row which is blank

  useEffect(() => {
    removeFilterTitle(".sr-only")
    const table = document.getElementById("download-certificate-table");

    if (table) {
      const tbody = table.querySelector('tbody');
      if (tbody) {
        const firstTr = tbody.querySelector('tr');
        
        if (firstTr) {
          tbody.removeChild(firstTr);
        }
      }
    }
  }, [sublist]);

  //  // remove filter title
  //  useEffect(()=>{
  //   removeFilterTitle(".sr-only")
  // }, []);

 



  const handleInput = (e) => {
    e.persist();
    setProduct({ ...productInput, [e.target.name]: e.target.value });
  };
  
  const handleEvent = (e) => {
    e.preventDefault();
    const vertical_name = e.target.value;
    setProduct({ ...productInput, [e.target.name]: e.target.value });
    axios.get(`api/get_verticaldata/${vertical_name}`).then(res =>{
      // const vertical_name = e.target.value;
    if(res.data.status===200){
      const data = res.data.Chalans;
      setsublist(res.data.Chalans);
      setsublist(oldArray => [data,...oldArray] );
    }
    });

    

}
const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });



  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: sublist.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };


const columns = [
  {
    dataField: "id",
    text: "ID",
    
      
  },
  {
    dataField: "memo_no",
    text: "Memo No",
  },
  {
    dataField: "party_code",
    text: "Party Code",
    filter: textFilter(),
    
       },
  {
    dataField: "date",
    text: "Date",
    filter: textFilter(),
      
  },
  {
    dataField: "month_of_test",
    text: "Month of Test",
    filter: textFilter(),
      
  },
  {
    dataField: "remarks",
    text: "Remarks",
   
  },
  /* {
  dataField: "category_id",
  text: "category_id",
},
{
  dataField: "sub_catgory_id",
  text: "sub_catgory_id",
},*/
  /* {
  dataField: "category_details_id",
  text: "category_details_id",
  
},*/
  {
    dataField: "vertical_type",
    text: "Vertical Type",
    

  },


  {
    dataField: "action",
    text: "Actions",
    formatter: (cell, row, rowIndex, formatExtraData) => {
      // console.log(row);
      const Chalans_id = row.id;
      const Verticle = row.vertical_type;
      // console.log(customerId);
      return (
        <ThemeProvider theme={theme}>
          <Grid container spacing={1}>
            
            <Grid item xs={1}>
            { Verticle === "IDLR" ? (
              <Button
                component={Link}
                to={`/certificates/create_certificate/${Chalans_id}`}
                color="apple"
                size="medium"
                startIcon={<EditIcon color="inherit" />}
              >
              </Button>
      ) : (
        <Button
                component={Link}
                to={`/certificates/create_industrial_certificate/${Chalans_id}`}
                color="apple"
                size="medium"
                startIcon={<EditIcon color="inherit" />}
              >
              </Button>
      )}
                
              
               </Grid>
           
            
          </Grid>
        </ThemeProvider>
      );
    },
  },
];



  return (
    <div style={{ marginTop: 20 }} >
      <Navbar  style={{ marginTop: 1 }} />
      <div className="card px-8 m-5">
        <div className="card-header">
          <div class="d-flex justify-content-between">
            <h4>Create Certificate</h4>
          </div>
              <select
                id="vertical_name"
                name="vertical_name"
                className="form-control"
                onChange={handleEvent}
                value={productInput.vertical_name}
              >
                <option value="">-- Verticle Type --</option>
                <option value="Industrial-MZ">Industrial-MZ</option>
                <option value="Industrial-MA">Industrial-MA</option>
                <option value="IDLR">IDLR</option>
              </select>
        </div>
        <BootstrapTable
          id="download-certificate-table"
          keyField="id"
          data={sublist}
          columns={columns}
          hover
          condensed
          // pagination={paginationFactory(options)}
            filter={filterFactory()}
            overlay={overlayFactory()}
            wrapperClasses="table-responsive"
        />
      </div>
    </div>
  );
}

export default Showcertificate;
